import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { customerActions } from "@sonic/Store/GemecoState";
import HeaderState from "@sonic/Store/Pages/Header/HeaderState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<HeaderState, DispatchProp<customerActions>>;

export const UpdateState: HandlerType = props => {
    props.dispatch({
        type: "Pages/Header/UpdateHeaderActive",
        parameter: props.parameter,
    });
};

export const chain = [UpdateState];

const updateHeaderActive = createHandlerChainRunner(chain, "UpdateHeaderActive");
export default updateHeaderActive;
